module.exports = __webpack_public_path__ + "img/u2.b678c360.png";